    (function() {
    'use strict';

    angular
        .module('as.search')
        .controller('SearchControllerV2', SearchControllerV2)

    SearchControllerV2.$inject = ['$scope', '$location', '$http', '$filter', '$window', 'asMessages', '$timeout', 'ModalService', 'suggestions', '$stateParams', 'sidetopHttp', '$state', '$rootScope', 'adminRights', 'invitation','getAdminMailFeedback'];

    function SearchControllerV2($scope, $location, $http, $filter, $window, asMessages, $timeout, ModalService, suggestions, $stateParams, sidetopHttp, $state, $rootScope, adminRights, invitation,getAdminMailFeedback) {
        //variable
        $scope.startSearchNow={};
        $scope.get_searchparams=get_searchparams;

        //function bindings
        if (platform && !$rootScope.onTabChangeFn.searchHandler) {
            // This CODE is not working right now.
            // setTimeout(function () {
            //     $rootScope.onTabChangeFn.searchHandler = {};
            //     $rootScope.onTabChangeFn.searchHandler.post = function (e) {
            //         if(e && e.tabItem && e.tabItem.page==="search-ui-view.tpl"){
            //             if($rootScope._stickyStateParams && $rootScope._stickyStateParams.search 
            //                     && $rootScope._stickyStateParams.search.time>0){
            //                 $stateParams = $rootScope._stickyStateParams.search.params;
            //                 console.log("_stickyStateParams.search",angular.copy($stateParams));
            //                 $rootScope._stickyStateParams.search = {};
            //                 setTimeout(function () {
            //                     var searchparams = get_searchparams();
            //                     if($scope.reportingFun && typeof($scope.reportingFun.vResetAll)==="function"){
            //                         $scope.reportingFun.vResetAll(searchparams);
            //                         setTimeout(function () {
            //                             $scope.reportingFun.searchDataInit(false);
            //                         },1000);
            //                     }
            //                 },50);
            //             }
            //         }
            //         else{
            //         }
            //     }
            // },100);
        }

        activate();

        function activate() {
            var searchparams = get_searchparams();
            var fixedparams=$stateParams.fp?JSON.parse($stateParams.fp):false;
            if(fixedparams){
               searchparams=merge_params(fixedparams.filters,searchparams);
            }
            // console.log('searchV2.controller.js:40', 'searchparams:', searchparams);
            $scope.searchInitialData={
                fetchLost:1,
                authenticated_only: true,
                dataParams: Object.keys(searchparams).filter(function(v) {
                    return ['metaTags','pageTitle'].indexOf(v)==-1;
                }).reduce(function(p,c) {
                    if(!p[c] && searchparams[c]!==undefined)
                        p[c] = [];
                    if(searchparams[c]!==undefined){
                        if(searchparams[c].constructor == Array)
                            p[c] = angular.merge(p[c],searchparams[c]);
                        else if(searchparams[c].constructor == Object)
                            p[c] = searchparams[c];
                        else
                            p[c].push(searchparams[c]);
                    }
                    return p;
                },{}),
                fields: {activeStatus: {hidden: false},marital_status: {hidden: true}},
                categories: [
                    {
                        fields: ["name"],
                        displayName: $filter("asLingo")(194,'','',"Keyword")
                    },
                    {
                        fields:["role","subinst","yoj","yop","institute","degree","department","specialization","enrollment_number","role_info_fields","identity_number"],
                        displayName: $filter("asLingo")(195,'','',"Filters")
                    },
                    { //send this category from out side if needed
                        fields:["membership_id","membership_number","life_membership_number"]
                    },
                    {
                        fields:["city","hometown","chapters","groups","company","designation","professional_networks","industry","skill","past_institute","past_degree","past_department","basic_info_fields","email","phone_number","gender","marital_status","dob"]
                    },
                    {
                        fields: ["entity_field","mobile_app","auth_status","activeStatus","account_type","login_status","account_created","import_id"]
                    }
                ]
            };
            if(angular.isDefined($stateParams.fp)){
                $scope.searchInitialData['fp']=fixedparams;
            }

            // $scope.options = {setFormFields:1, sendMailEnabled:0};
            //indexOfFormFields is deprecated now if you want role_related_custom_field at specific index then use 'role_info_fields' and for basic_related_custom_field then use 'basic_info_fields'
            $scope.options = { setFormFields:1,setEntityFields:1, split_entity_categories:true,indexOfFormFields:2, sendMailEnabled:1, view:{name:"directory", doNotSaveFieldConfig:true, availabeFields:["email","company","designation","role","institute","subinst","membership_id","membership_number","enrollment_number","identity_number","yop","yoj","degree","department","specialization","phone_number","city"],disabledFields:["email","company","designation","role","institute","subinst","membership_id","membership_number","enrollment_number","identity_number","yop","yoj","degree","department","specialization","phone_number","city"]},extend_controllers:['SearchMainPage'],include_demised:true};
            $scope.options.view.default_fields = [];
            if(angular.isDefined($rootScope.app_data.config.meta[52]) && angular.isDefined($rootScope.app_data.config.meta[52].default_fields)){
                $scope.options.view.default_fields = $rootScope.app_data.config.meta[52].default_fields;
            }
            if($scope.options.view.default_fields.length == 0)
                $scope.options.view.default_fields = ['email','company','designation'];
            for (var i = $scope.options.view.default_fields.length - 1; i >= 0; i--) {
                var disableIndex = $scope.options.view.disabledFields.indexOf($scope.options.view.default_fields[i]);
                var availableIndex = $scope.options.view.availabeFields.indexOf($scope.options.view.default_fields[i]);
                if(disableIndex!==-1){
                    $scope.options.view.disabledFields.splice(disableIndex,1);
                    $scope.options.view.availabeFields.splice(availableIndex,1);
                    $scope.options.view.availabeFields.unshift($scope.options.view.default_fields[i]);
                }
            }
            $scope.options.enableViewMode = true;
            $scope.options.stickyStateScrollBlock = 'inapp.search';
            if($rootScope.app_data.data.insti_type!=3)
                $scope.options.view.availabeFields.splice($scope.options.view.availabeFields.indexOf("subinst"),1);
            if(!$rootScope.featureEnabled('membership',false)){
                $scope.options.view.availabeFields.splice($scope.options.view.availabeFields.indexOf("membership_id"),1);
                $scope.options.view.availabeFields.splice($scope.options.view.availabeFields.indexOf("membership_number"),1);
            }
            if (chk_restrictions_return(24)) {
                $scope.searchInitialData.restricted = true;
            }

            if(angular.isDefined($rootScope.app_data.config.meta[52]) && angular.isObject($rootScope.app_data.config.meta[52]['search_init_data'])){
                angular.merge($scope.searchInitialData, $rootScope.app_data.config.meta[52]['search_init_data']);
            }

            if(angular.isDefined($scope.searchInitialData['extend_categories']) && angular.isArray($scope.searchInitialData['extend_categories'])){
                angular.forEach($scope.searchInitialData['extend_categories'], function(ext_cat, index){
                    angular.forEach($scope.searchInitialData['categories'], function(cat, index){
                        if(angular.isArray(ext_cat['extend_fields']) && ext_cat['displayName']==cat['displayName'] && angular.isArray(cat['fields'])){
                            cat['fields'] = cat['fields'].concat(ext_cat['extend_fields']);
                        }
                    });    
                });
            }

            $scope.reportingFun = {
                fetchingProfiles: function(report) {
                    // console.log('fetchingProfiles', 'report:', report);
                    report.dataTosend.directory = true;
                    var _report = angular.copy(report);
                    setUrlQuery(_report.dataTosend.queryString?_report.dataTosend.queryString:_report.dataTosend);
                }
            };

            $timeout(function () {
	            $scope.startSearchNow.start();                        	
            },300);

            askForFeedback();

        }
        // merges fixed_params and search_params
        function merge_params(fp,sp){
            var mergedParams={};
            for (var key in fp) {
                if (Object.prototype.hasOwnProperty.call(fp, key)) {
                    mergedParams[key] = fp[key];
                }
            }
            for (var key in sp) {
                if (Object.prototype.hasOwnProperty.call(sp, key)) {
                    mergedParams[key] = sp[key];
                }
            }
            return mergedParams;
        }

        function get_searchparams() {
            var searchparams = $stateParams.searchparams?JSON.parse($stateParams.searchparams):{};
            // console.log('$stateParams',$stateParams);
            searchparams = Object.keys($stateParams).filter(function(v) {
                    return ['metaTags','pageTitle','searchparams','form','rnd','fp'].indexOf(v)==-1;
                }).reduce(function(p,k) {
                    var c = $stateParams[k];
                    if(isNullUndefined(c))
                        return p;
                    if(searchparams[k]) {
                        delete searchparams[k];
                    }
                    if(!p[k]) {
                        p[k] = [];
                    }
                    if(c.constructor == Array)
                        p[k] = angular.merge(p[k],c);
                    else
                        p[k].push(c);
                    return p;
                },searchparams);
            return searchparams;
        }


        function askForFeedback(){
            if(!$rootScope.app_data.isAdmin) return false;
            var promise = $timeout(function(){
                getAdminMailFeedback.askForFeedback("Directory",{
                    formDescription: 'Hi '+$rootScope.app_data.fname+' '+$rootScope.app_data.lname+',<br>Please rate you your today\'s experience with <span class="mdl-typography--font-regular">Directory</span>. Your feedback will help us create a better experience.'
                });
            }, 3*60000);
            $scope.$on('$destroy', function(){
                $timeout.cancel(promise);
            });
        }


        
        function setUrlQuery(queryString) {
            console.log('setUrlQuery', 'queryString:',angular.copy(queryString));
            if($state.current.name != 'inapp.search')
                return;
            delete queryString.stream;
            delete queryString.other_params;
            queryString = Object.keys(queryString).filter(function(v) {
                return ['form','rnd'].indexOf(v)==-1;
            }).reduce(function(p,k) {
                var c = queryString[k];
                if(c.constructor !== Array || (c.constructor == Array && c.length>0))
                    p[k] = c;
                return p;
            },{});
            var d = {searchparams:undefined};
            if($stateParams.fp){
                d['fp']=undefined;
            }
            if(Object.keys(queryString).length>0)
                var d = {searchparams:JSON.stringify(queryString)};
            if($stateParams.fp){
                d['fp']=JSON.stringify(JSON.parse($stateParams.fp));
            }
            $state.go('.',
                d,
                {
                    notify: false,
                    location: 'replace',
                    inherit: false
                }
            );
        }


    }

})();